import axiosInstance from "./axiosInstance";

export const getPortfolio = async () => {
  try {
    const response = await axiosInstance.get("/public/portfolio", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch portfolio");
  }
};

export const getPortfolioById = async (id) => {
  try {
    const response = await axiosInstance.get(`/portfoliofetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch portfolio item");
  }
};

export const createPortfolio = async (formData) => {
  try {
    const response = await axiosInstance.post("/portfolio", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create portfolio");
  }
};

export const updatePortfolio = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`/portfolio/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to update portfolio");
  }
};

export const deletePortfolio = async (id) => {
  try {
    const response = await axiosInstance.delete(`/portfolio/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete portfolio");
  }
};